module.exports = __webpack_public_path__ + "static/media/video.f7443c83.png";